type BootstrapOpts = {
  clientAccessToken: string;
  onSuccess?: () => void;
  onFailure?: (err: any) => void;
};

export const bootstrapMarqetaJS = ({
  clientAccessToken,
  onSuccess,
  onFailure,
}: BootstrapOpts): void => {
  window.marqeta.bootstrap({
    clientAccessToken,
    containerId: "marqeta-js-container",
    integrationType: "custom",
    showPan: {
      cardPan: {
        domId: "mq-card-pan",
        format: true,
        styles: {
          span: {
            color: "white",
            "font-family":
              "'Italian Plate No2 Expanded',Roboto,Helvetica,Arial,sans-serif",
            "letter-spacing": "1px",
            "font-weight": "bold",
          },
        },
      },
      cardExp: {
        domId: "mq-card-exp",
        format: true,
        styles: {
          span: {
            color: "white",
            "font-family":
              "'Italian Plate No2 Expanded',Roboto,Helvetica,Arial,sans-serif",
            "font-size": "12px",
          },
        },
      },
      cardCvv: {
        domId: "mq-card-cvv",
        styles: {
          span: {
            color: "white",
            "font-family":
              "'Italian Plate No2 Expanded',Roboto,Helvetica,Arial,sans-serif",
            "font-size": "12px",
          },
        },
      },
    },
    callbackEvents: {
      onSuccess,
      onFailure,
    },
  });
};
